import { useCallback } from 'react';
import { useCropContext } from '../../../../context/crop-context';
import { useSaveProject } from '../../../../hooks';
import { useUIStore } from '../../../../stores/ui';
import { useHistoryTransaction, useHistoryTransactionErrorToast } from '../../../../features/edit-history/edit-history';

type UseCropToolActions = {
  onFinish: () => Promise<void>;
  onCancel: () => void;
};

export const useCropToolActions = (): UseCropToolActions => {
  const { finishCropping, cancelCropping, startCropping } = useCropContext();
  const { saveProject } = useSaveProject();
  const runHistoryTransaction = useHistoryTransaction();
  const showHistoryTransactionError = useHistoryTransactionErrorToast();
  const setActiveTool = useUIStore((state) => state.setImageEditToolbarActiveTool);

  const onFinish = useCallback(async () => {
    if (!finishCropping) {
      return;
    }
    try {
      await finishCropping(runHistoryTransaction);
    } catch {
      startCropping();
      showHistoryTransactionError();
      return;
    }
    setActiveTool(null);
    saveProject({ showLoadingScreen: false, shouldRestoreCanvas: false, generateFrontPreview: false });
  }, [finishCropping, runHistoryTransaction, saveProject, setActiveTool, showHistoryTransactionError, startCropping]);

  const onCancel = useCallback(() => {
    cancelCropping();
    setActiveTool(null);
  }, [cancelCropping, setActiveTool]);

  return { onFinish, onCancel };
};
